import React from 'react';
import '../assets/MonthYearNavigator.css';

const MonthYearNavigator = ({ 
  selectedMonth, 
  selectedYear, 
  onMonthChange, 
  onYearChange,
  showLabel = true 
}) => {
  const months = [
    { value: 1, label: 'January', short: 'Jan' },
    { value: 2, label: 'February', short: 'Feb' },
    { value: 3, label: 'March', short: 'Mar' },
    { value: 4, label: 'April', short: 'Apr' },
    { value: 5, label: 'May', short: 'May' },
    { value: 6, label: 'June', short: 'Jun' },
    { value: 7, label: 'July', short: 'Jul' },
    { value: 8, label: 'August', short: 'Aug' },
    { value: 9, label: 'September', short: 'Sep' },
    { value: 10, label: 'October', short: 'Oct' },
    { value: 11, label: 'November', short: 'Nov' },
    { value: 12, label: 'December', short: 'Dec' }
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 2019 + 6 }, (_, i) => 2019 + i);

  const handlePrevMonth = () => {
    if (selectedMonth === 1) {
      onMonthChange(12);
      onYearChange(selectedYear - 1);
    } else {
      onMonthChange(selectedMonth - 1);
    }
  };

  const handleNextMonth = () => {
    if (selectedMonth === 12) {
      onMonthChange(1);
      onYearChange(selectedYear + 1);
    } else {
      onMonthChange(selectedMonth + 1);
    }
  };

  const currentMonthLabel = months.find(m => m.value === selectedMonth)?.label || '';

  return (
    <div className="month-year-navigator">
      {showLabel && <label className="navigator-label">Period:</label>}
      
      <div className="navigator-controls">
        <button 
          className="nav-btn prev-btn" 
          onClick={handlePrevMonth}
          title="Previous month"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 18l-6-6 6-6"/>
          </svg>
        </button>

        <div className="current-period">
          <span className="period-display">
            {currentMonthLabel} {selectedYear}
          </span>
        </div>

        <button 
          className="nav-btn next-btn" 
          onClick={handleNextMonth}
          title="Next month"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </button>

        <div className="dropdown-selectors">
          <select 
            value={selectedMonth} 
            onChange={(e) => onMonthChange(parseInt(e.target.value))}
            className="month-select"
          >
            {months.map(month => (
              <option key={month.value} value={month.value}>
                {month.label}
              </option>
            ))}
          </select>

          <select 
            value={selectedYear} 
            onChange={(e) => onYearChange(parseInt(e.target.value))}
            className="year-select"
          >
            {years.map(year => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default MonthYearNavigator;
